import Vue from 'vue'
import { format } from 'date-fns'
import { thousand } from '@/libs/utils'

Vue.filter('dotDate', (value, defaultString) => {
  if (!value) {
    return defaultString || null
  }
  return format(new Date(value), 'yyyy. MM. dd')
})

Vue.filter('dashDate', (value, defaultString) => {
  if (!value) {
    return defaultString || null
  }
  return format(new Date(value), 'yyy-MM-dd')
})

Vue.filter('dateAndTime', value => {
  return format(new Date(value), 'YYYY-MM-DD HH:mm:ss')
})

Vue.filter('thousand', value => {
  return thousand(value)
})
